export default class WidgetInitializerService {
    private static counter: number = 0;

    static createIdentifier(): string {
        ++this.counter;

        return '' + this.counter;
    }
}
